import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import BenfitsCards from "./BenfitsCards";

const textVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
  }),
};

const Benefits = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const text = "Discover the Advantages of Fractional Ownership in Real Estate Today";
  const characters = text.split("");

  return (
    <section className="section-benefits section-help" ref={ref}>
      <div className="tf-container tf-spacing-1">
        <div className="row">
          <div className="col-12">
            <div className="box-benefits d-flex align-items-center">
              <h2 className="title text-start balance text-h2">
                {characters.map((char, i) => (
                  <motion.span
                    key={i}
                    className="inline-block"
                    variants={textVariants}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    custom={i}
                  >
                    {char}
                  </motion.span>
                ))}
              </h2>
              <div className="content">
                <motion.div
                  className="description"
                  initial={{ opacity: 0, x: -30 }}
                  animate={inView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
                >
                  <p className="text-1">
                    Investing in real estate doesn't have to be out of reach. With fractional
                    ownership, it's a smart way to diversify your portfolio without the hassle.
                  </p>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <BenfitsCards />
        </div>
      </div>
    </section>
  );
};

export default Benefits;
